import { defineComponent as _defineComponent } from 'vue'

import { useRoute } from 'vue-router'
  import store from "@/store";
  import { getTrainsUrl } from "@/api/index";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'trains',
  setup(__props) {

  const route = useRoute()
  const _getTrainsUrl = async () => {
    const res = await getTrainsUrl({
      iccid: route.params.iccid,
    });
    if (res.result.watchesRechargeUrlString === '' || res.result.watchesRechargeUrlString === null || res.result.watchesRechargeUrlString === undefined) return;
    store.commit('setKfUrl', res.result.watchesCustomerServiceUrl)
    window.location.href = res.result.watchesRechargeUrlString;
  };
  _getTrainsUrl();

return (_ctx: any,_cache: any) => {
  return null
}
}

})